// extracted by mini-css-extract-plugin
var _1 = "MultiValuedListItems-moduleMultiValuedListItems__sFyGz";
var _2 = "MultiValuedListItems-modulelarge__gsDFE";
var _3 = "MultiValuedListItems-modulemedium__b9ZEV";
var _4 = "MultiValuedListItems-modulesmall__xdHtC";
var _5 = "MultiValuedListItems-modulex-large__ZojYn";
var _6 = "MultiValuedListItems-modulex-small__sf0OL";
export { _1 as "MultiValuedListItems", _2 as "large", _3 as "medium", _4 as "small", _5 as "x-large", _6 as "x-small" }
